import { Box, Chip, Tooltip } from '@mui/material';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { Color } from 'shared/utils/colors';
import { REPORT_FILTER_CHIP_LABEL_SX, REPORT_FILTER_CHIP_SX } from './styles';

export function ReportFilterChip({
  selected,
  labelId,
  tooltipId,
  onClick,
  'data-qa': dataQa,
}: {
  selected: boolean;
  labelId: string;
  tooltipId?: string;
  onClick: () => void;
  'data-qa'?: string;
}): ReactElement {
  const intl = useIntl();
  const label = formatTranslation(intl, unsafeTranslationKey(labelId) );

  const chip = (
    <Chip
      clickable
      onClick={onClick}
      data-qa={dataQa}
      label={
        <Box
          component='span'
          data-label={label}
          sx={REPORT_FILTER_CHIP_LABEL_SX}
        >
          {label}
        </Box>
      }
      variant='outlined'
      sx={{
        ...REPORT_FILTER_CHIP_SX,
        ...(selected
          ? {
              borderColor: Color.border,
              bgcolor: Color.primaryOrangePale,
              color: 'text.primary',
              '&:hover': {
                bgcolor: Color.primaryOrangePale,
                borderColor: Color.border,
              },
            }
          : {
              borderColor: Color.neutralBorderGray,
              color: 'text.secondary',
              bgcolor: 'background.paper',
            }),
      }}
    />
  );

  if (!tooltipId) {
    return chip;
  }

  return (
    <Tooltip
      title={formatTranslation(intl, unsafeTranslationKey(tooltipId) )}
      arrow
      placement='top'
    >
      {chip}
    </Tooltip>
  );
}
